
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_zpcho_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_zpcho_14",
  "token-field-container": "awsui_token-field-container_vm8qf_zpcho_18",
  "token-field": "awsui_token-field_vm8qf_zpcho_18",
  "token-field-disabled": "awsui_token-field-disabled_vm8qf_zpcho_56",
  "token-field-readonly": "awsui_token-field-readonly_vm8qf_zpcho_64",
  "token-field-invalid": "awsui_token-field-invalid_vm8qf_zpcho_70",
  "token-field-warning": "awsui_token-field-warning_vm8qf_zpcho_82",
  "grouped": "awsui_grouped_vm8qf_zpcho_94",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vm8qf_zpcho_100",
  "grouped-in-error": "awsui_grouped-in-error_vm8qf_zpcho_107",
  "grouped-in-warning": "awsui_grouped-in-warning_vm8qf_zpcho_112",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vm8qf_zpcho_127",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vm8qf_zpcho_151",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vm8qf_zpcho_178",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vm8qf_zpcho_205",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vm8qf_zpcho_229",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_vm8qf_zpcho_256",
  "grouped-vertical-only": "awsui_grouped-vertical-only_vm8qf_zpcho_256",
  "grouped-with-action": "awsui_grouped-with-action_vm8qf_zpcho_286",
  "grouped-validation": "awsui_grouped-validation_vm8qf_zpcho_296",
  "token-field-icon": "awsui_token-field-icon_vm8qf_zpcho_300",
  "token-list": "awsui_token-list_vm8qf_zpcho_306",
  "inline-tokens": "awsui_inline-tokens_vm8qf_zpcho_320",
  "token-list-item": "awsui_token-list-item_vm8qf_zpcho_324",
  "token-input-wrapper": "awsui_token-input-wrapper_vm8qf_zpcho_328",
  "token-overflow": "awsui_token-overflow_vm8qf_zpcho_335",
  "token-overflow-trigger": "awsui_token-overflow-trigger_vm8qf_zpcho_339",
  "overflow-dropdown": "awsui_overflow-dropdown_vm8qf_zpcho_343",
  "overflow-dropdown-item": "awsui_overflow-dropdown-item_vm8qf_zpcho_352",
  "measurement-container": "awsui_measurement-container_vm8qf_zpcho_358",
  "measurement-token": "awsui_measurement-token_vm8qf_zpcho_371"
};
  